module.exports = __webpack_public_path__ + "img/Medellin.ebf47591.jpg";